import { useSyncExternalStore } from 'react';
import { isFeatureFlagEnabled, subscribeToFeatureFlags } from '../services/featureFlags';

export function useFeatureFlag(flagName: string): boolean {
  return useSyncExternalStore(subscribeToFeatureFlags, () => isFeatureFlagEnabled(flagName));
}
